"use client";

import * as React from "react";
import Link from "next/link";
import { BookOpen, History, Sparkles, ArrowRight } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const CARDS = [
  {
    href: "/docs/changelogs",
    title: "Changelogs",
    description:
      "Todas las versiones y los cambios incluidos en cada una. Selecciona una versión para ver el detalle.",
    icon: History,
    available: true,
  },
  {
    href: "/docs/manual",
    title: "Manual de usuario",
    description:
      "Guía paso a paso por rol y por módulo. Cómo configurar tu restaurante y operar el día a día.",
    icon: BookOpen,
    available: false,
  },
] as const;

export function DocsLanding() {
  return (
    <div className="not-prose space-y-8">
      <div className="space-y-3">
        <Badge variant="outline" className="gap-1 border-primary/40 bg-primary/10 text-primary">
          <Sparkles className="h-3 w-3" />
          Documentación
        </Badge>
        <h1 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
          Centro de ayuda Orkestria
        </h1>
        <p className="max-w-2xl text-sm text-muted-foreground sm:text-base">
          Todo lo que necesitas para sacarle el máximo a Orkestria. Si tienes
          dudas mientras navegas, pregúntale a <strong className="text-foreground">Faki</strong> — está
          listo para guiarte.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {CARDS.map((c) => {
          const Icon = c.icon;
          const inner = (
            <Card className="group h-full border-border/70 bg-card transition-all hover:border-primary/40 hover:shadow-sm">
              <CardContent className="flex h-full flex-col gap-4 p-6">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-5 w-5" />
                  </div>
                  {!c.available && (
                    <Badge variant="secondary">Próximamente</Badge>
                  )}
                </div>
                <div className="space-y-1.5">
                  <h2 className="text-base font-semibold tracking-tight text-foreground">
                    {c.title}
                  </h2>
                  <p className="text-sm text-muted-foreground">{c.description}</p>
                </div>
                {c.available && (
                  <div className="mt-auto flex items-center gap-1.5 pt-2 text-xs font-medium text-primary opacity-0 transition-opacity group-hover:opacity-100">
                    Abrir
                    <ArrowRight className="h-3.5 w-3.5" />
                  </div>
                )}
              </CardContent>
            </Card>
          );
          return c.available ? (
            <Link key={c.href} href={c.href} className="block">
              {inner}
            </Link>
          ) : (
            <div
              key={c.href}
              aria-disabled
              className="block cursor-not-allowed opacity-70"
            >
              {inner}
            </div>
          );
        })}
      </div>
    </div>
  );
}
